import type React from 'react'
import type { IconProps } from './types'

const Filters: React.FC<IconProps> = ({ size = 20, className = 'fill-neutral-900' }) => (
	<svg
		width={size}
		height={size}
		viewBox='0 0 24 24'
		className={className}
		fill='currentColor'
		xmlns='http://www.w3.org/2000/svg'
		aria-hidden='true'>
		<path d='M10 18V16H14V18H10ZM6 13V11H18V13H6ZM3 8V6H21V8H3Z' />
	</svg>
)

export default Filters
